
import React from 'react';
import { motion } from 'framer-motion';
import Layout from '@/components/Layout';
import ProfileManagement from '@/components/ProfileManagement';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { useTranslatedDocumentTitle } from '@/hooks/useDocumentTitle';

const Profile = () => {
  const { loading } = useAuth();
  const { t } = useTranslation();
  
  // Set page title using the hook
  useTranslatedDocumentTitle('profile.title');

  return (
    <Layout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="container mx-auto py-8 md:py-12 px-4"
      >
        <div className="max-w-4xl mx-auto">
          {loading ? (
            <div className="flex justify-center py-8">{t('profile.loading')}</div>
          ) : (
            <ProfileManagement />
          )}
        </div>
      </motion.div>
    </Layout>
  );
};

export default Profile;
